import React from "react";
import TableHeader from "../../Common/TableHeader";
import Loader from "../../Common/Loader";

function TermlyFeesPerSchool({schoolTermlyFees, loading}) {

    return (
        <div className="col-lg-12">
                      <div className="card custom-card" style={{paddingBottom:"10px"}}>
                        <div className="card-body map-card">
                        <TableHeader
                            title="Termly Fee Invoices Per School"
                            subtitle="Total amount of termly fees for each school"
                            
                        />
                        
    {loading ?(
  <Loader/>
) : (
  <table className="table mb-0 mw-100 color-span">
    <thead>
                <tr>
                <th className="w-50">School</th>
                <th className="py-2 px-0" scope="col">Invoice Count</th>
                <th className="py-2 px-0" scope="col">Amount Paid</th>
                </tr>
                </thead>
    <tbody style={{fontSize:"14px"}}>
        {Array.isArray(schoolTermlyFees) && schoolTermlyFees.map((item, key) => (
                                                <tr key={key}>
          <td className="py-2 px-0">
            <span className="w-50">{item.school_name}</span>
          </td>
          <td className="py-2 px-0">
            <span className="">
            {item.invoice_count? item.invoice_count?.total_c:"..."}
            </span>
          </td>
          <td className="py-2 px-0">
            <span className="">
            UGX. {item.amount_paid? item.amount_paid?.total_c:"..."}
            </span>
          </td>
        </tr>
                                            ))}
                                            {schoolTermlyFees === "404" && (<tr>
                                                <td colSpan="3" style={{textAlign: "center"}}>
                                                    No termly fees received.
                                                </td>
                                            </tr>)}
       
    </tbody>
  </table>
)}

                        </div>
                      </div>
                    </div>
        
    );
}

export default TermlyFeesPerSchool;
